import $ from 'jquery'

$(function ($) {
	if (!$('#world-map').length) {
		return
	}
	const $pins = $('.pin')
	const $zones = $('.zone')
	$zones.on('mouseover', function () {
		$(this).addClass('is-active ').siblings().removeClass('is-active')
		let id = $(this).attr('id')
		$pins
			.filter('[data-link="' + id + '"]')
			.addClass('is-active')
			.siblings()
			.removeClass('is-active')
	})

	$zones.on('mouseleave', function () {
		let id = $(this).attr('id')
		$(this).removeClass('is-active ')
		$pins.filter('[data-link="' + id + '"]').removeClass('is-active')
	})

	$zones.on('click', function () {
		let id = $(this).attr('id')
		window.location.href = $pins
			.filter('[data-link="' + id + '"]')
			.attr('data-href')
	})
})
